import type React from "react"
import { Button, Box, type SxProps, type Theme } from "@mui/material"

interface CustomButtonProps {
    onClick: () => void
    buttonSx?: SxProps<Theme>;
    innerCircleSx?: SxProps<Theme>;
    size?: number;
    sizeInnerCircle?: number;
}

const ButtonStart: React.FC<CustomButtonProps> = ({ onClick, buttonSx, innerCircleSx, size = 60, sizeInnerCircle = 24 }) => {
    return (
        <Button
            sx={{
                width: size,
                height: size,
                minWidth: size,
                borderRadius: "50%",
                bgcolor: "#FF4B4B",
                "&:hover": {
                    bgcolor: "#FF3333",
                },
                ...buttonSx,
            }}
            onClick={onClick}
        >
            <Box
                sx={{
                    width: sizeInnerCircle,
                    height: sizeInnerCircle,
                    borderRadius: "50%",
                    bgcolor: "white",
                    ...innerCircleSx,
                }}
            />
        </Button>
    )
}

export default ButtonStart

